'use client'

import { TArticleData } from 'store/types/article'

import { ArticlesList } from '@/screens/News'

type Props = {
	news: TArticleData
}

const NewsPageContent = ({ news }: { news: TArticleData }) => {
	return (
		<>
			<ArticlesList urlLocation="news" title="Новости" news={news.ITEMS} />
		</>
	)
}

export function NewsClient({ news }: Props) {
	return <NewsPageContent news={news} />
}
